import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const storeProviderBenefitsStability = createAsyncThunk(
    "provider/providerBenefitsStability",
    async ({ token, formData }, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/benefits-intake`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
        }
    }
);

export const storeFreeProviderBenefitsStability = createAsyncThunk(
    "provider/freeProviderBenefitsStability",
    async ({ token, formData }, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/free_benefits-intake`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
        }
    }
);

export const startFreePilot = createAsyncThunk(
    "provider/providerstartFreePilot",
    async (token, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/pilotstore`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
        }
    }
);

export const fetchProviderBenefitsIntakeData = createAsyncThunk(

    "provider/benefitsInstakeData",
    async (token, thunkAPI) => {
        try {
            const res = await axios.get(
                `${BACKEND_URL}/benfitsIntakeDetails`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
        }
    }
)

const providerBenefitsStabillity = createSlice({
    name: "providerBenefitsStabillity",
    initialState: {
        providerBenefitsStabilityData: [],
        benefitsIntakeData: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(storeProviderBenefitsStability.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(storeProviderBenefitsStability.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message;
            })
            .addCase(storeProviderBenefitsStability.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || "Something went wrong";
                state.validationErrors = action.payload?.errors || {};
            })
            .addCase(storeFreeProviderBenefitsStability.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(storeFreeProviderBenefitsStability.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message;
            })
            .addCase(storeFreeProviderBenefitsStability.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || "Something went wrong";
                state.validationErrors = action.payload?.errors || {};
            })
            .addCase(fetchProviderBenefitsIntakeData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProviderBenefitsIntakeData.fulfilled, (state, action) => {
                state.loading = false;
                state.benefitsIntakeData = action.payload;
            })
            .addCase(fetchProviderBenefitsIntakeData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(startFreePilot.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(startFreePilot.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message;
            })
            .addCase(startFreePilot.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || "Something went wrong";
                state.validationErrors = action.payload?.errors || {};
            })
    },
});

export default providerBenefitsStabillity.reducer;
